import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

export const useCompareVehicles = (uuid) => {
	const { compareVehicles } = useSelector((state) => state.compareVehicles);
	const containsVehicle = useCallback(
		() => compareVehicles.length && compareVehicles.includes(uuid),
		[compareVehicles, uuid]
	);
	const [selected, setSelected] = useState(containsVehicle);

	return {
		selected,
		setSelected,
		containsVehicle,
		compareVehicles
	};
};
